import * as React from 'react';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { AppUser } from 'Src/views/App/App';
import { Loader } from 'Src/components/Loader/Loader';
import { History, Location } from 'history';
import { Tournament } from 'Src/models/tournament';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { getSeason, getStartTime, getTournamentTagNamesPublicOnly } from 'Src/helpers/accessor/accessor';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import {
  getSelectOptionForSeason,
  getSelectOptionForUpcomingTournamentsSeason,
  getSelectOptionForBooleanQuestion,
  getSelectOptionForTournamentTag
} from 'Src/helpers/table/select';
import {
  getAllUpcomingHighLevelTournaments,
  getUpcomingHighLevelTournaments,
  getUpcomingHighLevelTournamentsCount
} from 'Src/helpers/service/adminSU/tournamentsTable';
import { getIsPromoteTournament, getIsPublishOnTheWebsite } from 'Src/helpers/accessor/accessor';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { isIndividualTournament, isMiniTeamTournament, isTeamTournament } from 'Src/helpers/tournament/tournament';
import { getAllSchoolUnionHighLevelTournamentTeams } from 'Src/helpers/service/adminSU/tournamentTeamsTable';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { uploadReport } from 'Src/helpers/service/admin/report';
import { HighLevelTournamentAreaStartListReportForm } from '../Reports/HighLevelTournamentAreaStartListReportForm/HighLevelTournamentAreaStartListReportForm';
import { HighLevelTournamentSchoolAdminsAreaSideReportForm } from '../Reports/HighLevelTournamentSchoolAdminsAreaSideReportForm/HighLevelTournamentSchoolAdminsAreaSideReportForm';
import { TournamentResultsIndividualParticipantSideReportForm } from '../Reports/TournamentResultsIndividualParticipantSideReportForm/TournamentResultsIndividualParticipantSideReportForm';
import {
  downloadHighLevelTournamentReport,
  getHighLevelTournamentReportModalProps,
  HighLevelTournamentReportErrorModal
} from '../Reports/HighLevelTournamentReportUi';
import '../../Tournaments/Tournaments.css';
import { TournamentStartCell, TournamentTagsCell } from '../../Tournaments/TournamentListCells';
import { ParticipantTournamentNameCell } from 'Src/views/GenericView/AdminView/Tournaments/ParticipantTournamentListCells';
import 'Src/views/GenericView/AdminView/Tournaments/TournamentsUpcoming/TournamentsUpcoming.scss';
import { HighLevelTournamentListDrawer } from '../HighLevelTournamentListDrawer';
import { HighLevelTournamentsListHeader } from '../HighLevelTournamentsListHeader';
import '../HighLevelTournaments.scss';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Tournament',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    cell: ParticipantTournamentNameCell
  },
  {
    text: 'Season',
    field: 'season',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getSeason
  },
  {
    text: 'Sport',
    field: 'sportId',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    filterControl: 'select',
    accessor: ['sport', 'name']
  },
  {
    text: 'Starts',
    field: 'startTime',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    cell: TournamentStartCell
  },
  {
    text: 'Tags',
    field: 'tournamentTagId',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: TournamentTagsCell
  }
];

interface State {
  isLoading: boolean;
  items: Tournament[];
  selectedItems: Tournament[];
  isSelectAllChecked: boolean;
  currentPage: number;
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filters: any;
  isDataFiltered: boolean;
  total: number;
  basePath: string;
  errorMessage: string;
  isErrorModalOpen: boolean;
  currentTabIndex: number;
  isHighLevelTournamentAreaStartListReportModalOpen: boolean; //062
  isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen: boolean; //064
  isTournamentResultsIndividualParticipantSideReportModalOpen: boolean; //03601
  tournamentTags: any[];
  drawerTournament?: Tournament;
  isReportsSelectionModalOpen: boolean;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class HighLevelTournamentsUpcoming extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      items: [],
      selectedItems: [],
      isSelectAllChecked: false,
      currentPage: FIRST_PAGE,
      currentTabIndex: 0,
      total: 0,
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      filters: {},
      isDataFiltered: false,
      basePath: '',
      errorMessage: '',
      isErrorModalOpen: false,
      isHighLevelTournamentAreaStartListReportModalOpen: false,
      isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen: false,
      isTournamentResultsIndividualParticipantSideReportModalOpen: false,
      tournamentTags: [],
      drawerTournament: undefined,
      isReportsSelectionModalOpen: false
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user, location } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;
    const lastSelectedFilters = propz.get(location, ['state', 'selectedFilters']);
    const isExistSelectedFilters = typeof lastSelectedFilters !== 'undefined';
    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = isExistSelectedFilters ? lastSelectedFilters : getFilters2(COLUMNS, search);
    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters, { isCorrectTime: true });

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getItemsPromise = getUpcomingHighLevelTournaments(user, serverQueryFilter);
    const getItemsCountPromise = getUpcomingHighLevelTournamentsCount(user, where);

    return BPromise.all([getItemsCountPromise, getItemsPromise]).then(([countObj, items]) => {
      const tournamentId = propz.get(location, ['state', 'tournamentId']);
      if (typeof tournamentId !== 'undefined') {
        const tournament = items.find(item => item.id === tournamentId);
        this.setState({
          currentPage: page,
          sortDirection,
          sortColumnsName,
          isShowFilter: isShowFilter,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: items,
          total: countObj.count,
          basePath: history.location.pathname,
          isLoading: false,
          selectedItems: typeof tournament !== 'undefined' ? [tournament] : []
        });

        //clear history
        const state = { ...(history.location.state as any) };
        delete state.tournamentId;
        history.replace({ ...history.location, state });
      } else {
        this.setState({
          currentPage: page,
          sortDirection: sortDirection,
          sortColumnsName: sortColumnsName,
          isShowFilter: isShowFilter,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: items,
          total: countObj.count,
          basePath: history.location.pathname,
          isLoading: false
        });
      }

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items } = this.state;
    const selectedItem = items[index];
    this.props.history.push({pathname: '/highLevelTournaments/participation/overview', search: `?tournamentId=${selectedItem.id}`,
      state: {participationReturnPath: this.props.location.pathname, participationReturnSearch: this.props.location.search}});
  };

  onItemSelect = (index: number): void => {
    const { items, selectedItems } = this.state;
    const item = items[index];
    const exists = selectedItems.some(selected => selected.id === item.id);
    this.setState({
      selectedItems: exists ? selectedItems.filter(selected => selected.id !== item.id) : [...selectedItems, item]
    });
  };

  closeTournamentDrawer = (): void => this.setState({ drawerTournament: undefined });
  openReportsSelectionModal = (): void => this.setState({ isReportsSelectionModalOpen: true });
  closeReportsSelectionModal = (): void => this.setState({ isReportsSelectionModalOpen: false });
  selectReport = (action: () => void): void =>
    this.setState({ isReportsSelectionModalOpen: false, drawerTournament: undefined }, action);

  renderReportsSelectionModal = (): React.ReactNode => {
    const { isReportsSelectionModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    if (!tournament) return null;
    const reports = [
      isIndividualTournament(tournament) && {
        name: 'Tournament start list',
        description: 'Start list for the selected individual tournament.',
        action: this.openHighLevelTournamentAreaStartListReportForm
      },
      isIndividualTournament(tournament) && {
        name: 'Tournament results',
        description: 'Results for the selected individual tournament.',
        action: this.openTournamentResultsIndividualParticipantSideReportForm
      },
      {
        name: 'Tournament schools contact details',
        description: 'Contact details for schools represented in this tournament.',
        action: this.openHighLevelTournamentSchoolAdminsAreaSideReportForm
      }
    ].filter(Boolean) as Array<{ name: string; description: string; action: () => void }>;
    return (
      <SimpleModal
        customClass="eEventPrintModal unionTournamentReportsModal"
        isOpen={isReportsSelectionModalOpen}
        title="Printed forms & reports"
        onCloseClick={this.closeReportsSelectionModal}
        showFooter={false}
        isBodyBold={false}
      >
        <div className="eEventPrintModal__intro">Choose a report. You can configure its contents on the next step.</div>
        <section className="eEventPrintModal__group">
          <h3 className="eEventPrintModal__groupTitle">Selected tournament reports</h3>
          <div className="eEventPrintModal__list">
            {reports.map(report => (
              <button
                type="button"
                className="eEventPrintModal__item"
                key={report.name}
                onClick={() => this.selectReport(report.action)}
              >
                <span className="eEventPrintModal__itemIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
                  </svg>
                </span>
                <span className="eEventPrintModal__itemCopy">
                  <span className="eEventPrintModal__itemHeading">
                    <span>{report.name}</span>
                    <span className="eEventPrintModal__format">Excel</span>
                  </span>
                  <span className="eEventPrintModal__itemDescription">{report.description}</span>
                </span>
                <span className="eEventPrintModal__arrow">›</span>
              </button>
            ))}
          </div>
        </section>
      </SimpleModal>
    );
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters, { isCorrectTime: true });

    getAllUpcomingHighLevelTournaments(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onTableFilterClick = (event): void => {
    event?.preventDefault?.();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = { ...this.state.filters };
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (options && options.modernRange) {
      nextFilters = {
        ...nextFilters,
        [filterField]: options.modernRange
      };
    } else if (options && options.modernMultiValue) {
      nextFilters = {
        ...nextFilters,
        [filterField]: Array.isArray(filterValue) ? filterValue : []
      };
    } else if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false,
      filters: {}
    });

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: ''
    });
  };

  onClearIndividualFilter = (filterField: string): void => {
    const { filters, sortDirection, sortColumnsName, basePath } = this.state;
    const nextFilters = { ...filters };
    delete nextFilters[filterField];
    const search: string[] = [];
    if (isSortExist(sortDirection, sortColumnsName)) search.push(getSearchOrder(sortDirection, sortColumnsName));
    if (isFilterExist2(nextFilters)) search.push(getSearchFilter(nextFilters));
    this.setState({ filters: nextFilters, selectedItems: [], isSelectAllChecked: false });
    this.props.history.push({ pathname: basePath, search: search.join('&') });
  };

  onCancelFilterClick = (): void => {
    this.setState({ isShowFilter: false }, () => this.setItems());
  };

  onManageTeamsClick = () => {
    const { history } = this.props;
    const { selectedItems, basePath } = this.state;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;
    const search = history.location.search;

    history.push({
      pathname: `/highLevelTournaments/teams`,
      search: `tournamentId=${tournamentId}`,

      state: {
        search,
        prevPath: basePath
      }
    });
  };

  onManageAthleteSchoolsClick = () => {
    const { history } = this.props;
    const { selectedItems, basePath } = this.state;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;
    const search = history.location.search;

    history.push({
      pathname: `/highLevelTournaments/athleteSchools`,
      search: `tournamentId=${tournamentId}`,
      state: {
        search,
        prevPath: basePath
      }
    });
  };

  onManageEventsClick = () => {
    const { history } = this.props;
    const { selectedItems, basePath } = this.state;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;
    const search = history.location.search;

    history.push({
      pathname: `/highLevelTournaments/events`,
      search: `tournamentId=${tournamentId}`,
      state: {
        search,
        prevPath: basePath
      }
    });
  };

  renderGrid = () => {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isSelectAllChecked,
      currentPage,
      total
    } = this.state;

    const actionItems = [
      {
        itemText: 'Manage Teams',
        onItemClick: this.onManageTeamsClick,
        isActive: this.isOneItemSelected()
      },
      {
        itemText: 'Manage Events',
        onItemClick: this.onManageEventsClick,
        isActive: this.isOneItemSelected()
      },
      {
        itemText: 'Manage athlete schools',
        onItemClick: this.onManageAthleteSchoolsClick,
        isActive: this.isOneItemSelected()
      },
      {
        itemText: 'Reports',
        onItemClick: this.openReportsSelectionModal,
        isActive: this.isOneItemSelected()
      }
    ].filter(Boolean);

    const filterOptions = {
      season: getSelectOptionForUpcomingTournamentsSeason(items),
      sportId: Array.from(
        new Map(
          items
            .filter(item => item.sportId && item.sport)
            .map(item => [item.sportId, { value: item.sportId, text: item.sport.name }])
        ).values()
      ),
      isPublishOnTheWebsite: getSelectOptionForBooleanQuestion(),
      isPromoteTournament: getSelectOptionForBooleanQuestion(),
      tournamentTag: getSelectOptionForTournamentTag(this.state.tournamentTags)
    };

    const todayMidnight = new Date(new Date().setHours(0, 0, 1));

    return (
      <div className="unionTournamentsModern unionTournamentsListShell highLevelTournamentsListShell">
        <HighLevelTournamentsListHeader
          user={this.props.user}
          history={this.props.history}
          activeSection="upcoming"
        />
        <div className="unionTournamentsListCard highLevelTournamentsListCard">
          <Grid2
          user={this.props.user}
          dataItems={items}
          filters={filters}
          currentPage={currentPage}
          total={total}
          isSelectAllChecked={isSelectAllChecked}
          isDataFiltered={isDataFiltered}
          sortDirection={sortDirection}
          sortColumnsName={sortColumnsName}
          isShowFilter={isShowFilter}
          dataItemsSelected={selectedItems}
          columns={COLUMNS}
          actionItems={actionItems}
          isCSV={false}
          options={filterOptions}
          onItemClick={this.onItemClick}
          onItemSelect={this.onItemSelect}
          onSortClick={this.onTableSortClick}
          onApplyFilterClick={this.onApplyFilterClick}
          onClearFilterClick={this.onClearFilterClick}
          onClearIndividualFilter={this.onClearIndividualFilter}
          onCancelFilterClick={this.onCancelFilterClick}
          onTableFilterChange={this.onTableFilterChange}
          onTableFilterClick={this.onTableFilterClick}
          setCurrentPageParams={this.setCurrentPageParams}
          onSelectAllClick={this.onSelectAllClick}
          onSelectAllOnPageClick={this.onSelectAllOnPageClick}
          onUnselectAllClick={this.onUnselectAllClick}
          filterMinDateInterval={todayMidnight}
          gridTitle={`${total} tournament${total === 1 ? '' : 's'}`}
          toolbarSearchField="name"
          toolbarSearchPlaceholder="Search tournaments..."
          onToolbarSearchClear={() => this.onClearIndividualFilter('name')}
          hiddenFilterFields={['name']}
          isActionsInline
          selectionActionsBelow
          defaultHiddenColumns={[]}
          fixedColumnFields={['name']}
          filterOnlyFields={['sportId']}
          columnVisibilityKey="union-high-level-upcoming-tournaments"
          emptyText="No high-level tournaments found"
          emptyHint="Try changing the filters."
          />
        </div>
      </div>
    );
  };

  isOneItemSelected(): boolean {
    const selectedItems = this.state.selectedItems;
    return selectedItems.length === 1;
  }

  onSubmitReportForm = (data, reportType) => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { selectedItems } = this.state;
    const tournament = selectedItems[0];
    const tournamentId = propz.get(tournament, ['id'], '');

    if (!tournamentId) {
      this.setState({
        errorMessage: 'Select a tournament before generating a report.',
        isErrorModalOpen: true
      });
      return;
    }

    const { isShowBlank, isHighlightNoAge, isPrintFullNames, isShowAllAdmins } = data;

    let modData;
    let formsUniq;

    switch (reportType) {
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.HIGH_LEVEL_TOURNAMENT_AREA_START_LIST:
        this.setState({
          isHighLevelTournamentAreaStartListReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showBlank: isShowBlank,
            highlightNoAge: isHighlightNoAge
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_RESULTS_INDIVIDUAL_PARTICIPANT_SIDE:
        this.setState({
          isTournamentResultsIndividualParticipantSideReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            participantSchoolId: activeSchoolId,
            tournamentId,
            showBlank: isShowBlank,
            printFullNames: isPrintFullNames
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.HIGH_LEVEL_TOURNAMENT_SCHOOL_ADMINS_AREA_SIDE:
        this.setState({
          isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showAllAdmins: isShowAllAdmins
          }
        };
        break;
    }

    if (!modData) {
      this.setState({
        isLoading: false,
        errorMessage: 'This report type is not available.',
        isErrorModalOpen: true
      });
      return;
    }

    uploadReport(user, reportType, modData)
      .then(result => {
        if (typeof result.reportId === 'undefined' || !result.reportType) {
          throw new Error('The report file was not returned by the server.');
        }

        downloadHighLevelTournamentReport(result);
        this.setState({ isLoading: false });
      })
      .catch(error => {
        const errorText =
          propz.get(error, ['response', 'data', 'details', 'text'], '') ||
          propz.get(error, ['response', 'data', 'message'], '') ||
          propz.get(error, ['message'], '') ||
          'The report could not be generated. Please try again.';
        console.error(error);

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  closeReportErrorModal = (): void => {
    this.setState({ isErrorModalOpen: false, errorMessage: '' });
  };

  openHighLevelTournamentAreaStartListReportForm = () => {
    this.setState({
      isHighLevelTournamentAreaStartListReportModalOpen: true
    });
  };

  closeHighLevelTournamentAreaStartListReportForm = () => {
    this.setState({
      isHighLevelTournamentAreaStartListReportModalOpen: false
    });
  };

  openTournamentResultsIndividualParticipantSideReportForm = () => {
    this.setState({
      isTournamentResultsIndividualParticipantSideReportModalOpen: true
    });
  };

  closeTournamentResultsIndividualParticipantSideReportForm = () => {
    this.setState({
      isTournamentResultsIndividualParticipantSideReportModalOpen: false
    });
  };

  openHighLevelTournamentSchoolAdminsAreaSideReportForm = () => {
    this.setState({
      isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen: true
    });
  };

  closeHighLevelTournamentSchoolAdminsAreaSideReportForm = () => {
    this.setState({
      isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen: false
    });
  };

  renderHighLevelTournamentAreaStartListReportFormModal() {
    const { isHighLevelTournamentAreaStartListReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return (
      <SimpleModal
        isOpen={isHighLevelTournamentAreaStartListReportModalOpen}
        {...getHighLevelTournamentReportModalProps(
          'Tournament start list',
          tournament,
          this.closeHighLevelTournamentAreaStartListReportForm
        )}
      >
        <HighLevelTournamentAreaStartListReportForm
          onCloseClick={this.closeHighLevelTournamentAreaStartListReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderTournamentResultsIndividualParticipantSideReportFormModal() {
    const { isTournamentResultsIndividualParticipantSideReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return (
      <SimpleModal
        isOpen={isTournamentResultsIndividualParticipantSideReportModalOpen}
        {...getHighLevelTournamentReportModalProps(
          'Tournament results',
          tournament,
          this.closeTournamentResultsIndividualParticipantSideReportForm
        )}
      >
        <TournamentResultsIndividualParticipantSideReportForm
          onCloseClick={this.closeTournamentResultsIndividualParticipantSideReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderHighLevelTournamentSchoolAdminsAreaSideReportFormModal() {
    const { isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return (
      <SimpleModal
        isOpen={isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen}
        {...getHighLevelTournamentReportModalProps(
          'Tournament schools contact details',
          tournament,
          this.closeHighLevelTournamentSchoolAdminsAreaSideReportForm
        )}
      >
        <HighLevelTournamentSchoolAdminsAreaSideReportForm
          onCloseClick={this.closeHighLevelTournamentSchoolAdminsAreaSideReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  render() {
    const {
      isLoading,
      isHighLevelTournamentAreaStartListReportModalOpen,
      isTournamentResultsIndividualParticipantSideReportModalOpen,
      isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isHighLevelTournamentAreaStartListReportModalOpen ||
      isTournamentResultsIndividualParticipantSideReportModalOpen ||
      isHighLevelTournamentSchoolAdminsAreaSideReportModalOpen
        ? 'highLevelTournamentsPage modal-open'
        : 'highLevelTournamentsPage';

    return (
      <div className={classes}>
        <HighLevelTournamentReportErrorModal
          isOpen={this.state.isErrorModalOpen}
          message={this.state.errorMessage}
          onClose={this.closeReportErrorModal}
        />
        {this.renderHighLevelTournamentAreaStartListReportFormModal()}
        {this.renderTournamentResultsIndividualParticipantSideReportFormModal()}
        {this.renderHighLevelTournamentSchoolAdminsAreaSideReportFormModal()}
        {this.renderReportsSelectionModal()}
        <HighLevelTournamentListDrawer
          user={this.props.user}
          tournament={this.state.drawerTournament}
          onClose={this.closeTournamentDrawer}
          onTeams={() => {
            this.closeTournamentDrawer();
            this.onManageTeamsClick();
          }}
          onEvents={() => {
            this.closeTournamentDrawer();
            this.onManageEventsClick();
          }}
          onAthleteSchools={() => {
            this.closeTournamentDrawer();
            this.onManageAthleteSchoolsClick();
          }}
        />
        {this.renderGrid()}
      </div>
    );
  }
}
